$('.image-slider').slick({
  infinite: true,
   dots: false,
    arrows: false,
  autoplay: true,
  autoplaySpeed: 1000,
   speed: 500,
  fade: true,
  cssEase: 'linear',
  slidesToShow: 1,
  slidesToScroll: 1
});



$(document).ready(function(){
  if($("#delivery_date").length){
    initDatePicker("Pickup");

    $("#delivery_date").on("change blur keyup", function(){
       checkCartValidation();
    });

    $(".select__timeslot").on("change", function(){
       checkCartValidation();
    });

    $("#delivery-type").on("change", function(){
      $("#delivery_date").val("");
      $("#time-slot").val("");
      $("#time-slot .pickup-timeslot, #time-slot .delivery-timeslot").remove();
      if($(this).val() == "Pickup"){
        $("#time-slot").append('<option class="pickup-timeslot" value="8am-12pm">8am-12pm</option><option class="pickup-timeslot" value="1pm-4pm">1pm-4pm</option>');
      }else{
        $("#time-slot").append('<option class="delivery-timeslot" value="3pm-6pm">3pm-6pm</option>');
      }
      checkCartValidation();
      $("#delivery_date").datepicker("destroy");
      initDatePicker($(this).val());
    });
  }

  if($("#checkbox-tnc").length){
    $("#checkbox-tnc").change(function(){
       checkCartValidation();
    });
  }
});

function initDatePicker(deliveryType){
      $("#delivery_date").datepicker({ 
        dateFormat: 'dd/mm/yy',
        minDate: +1, 
        maxDate: "+2M",
        beforeShowDay: function(date) {
            var day = date.getDay(); // 0 = Sunday, 1 = Monday, etc.

            if(deliveryType == "Delivery"){
              return [ (day === 4) ]; // Only allow Thursday (index 4)
            }else{
              return [(day > 0 && day < 7 ), ''];  // Disable only Sunday
            }
        },
        onSelect: function(date) {
            console.log(date);
            checkCartValidation();
        }
      });
}

function checkCartValidation(){
  var deliveryDate = $("#delivery_date").val();
  var checkboxTNC = $("#checkbox-tnc");
  var selectTimeslot = $(".select__timeslot").val();
  if(deliveryDate != '' && checkboxTNC.is(":checked")){
    $(".cart__checkout-button.button").removeAttr("disabled");
    $(".cart_attributes_date").val(deliveryDate);
    $(".cart_attributes_time").val(selectTimeslot);
  }else{
    $(".cart__checkout-button.button").attr("disabled", "disabled");
  }
}


// URL redirect for old website
var currURL = window.location.href;
if(currURL.indexOf("com.au/shop-online") != -1){
  window.location.href = "/collections/2024-christmas-menu";
}
if(currURL.indexOf("com.au/contact") != -1){
  window.location.href = "/pages/contact";
}
if(currURL.indexOf("com.au/trading-hours") != -1){
  window.location.href = "/pages/trading-hours";
}
if(currURL.indexOf("com.au/ethos") != -1){
  window.location.href = "/pages/ethos";
}